import React from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import store from "./redux/store";
import "./index.css";
import ThemeProvider from "./theme";
import GoogleAuthProvider from "./utils/GoogleAuthProvider";

const persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Provider store={store}>
        <ThemeProvider>
          <PersistGate loading={null} persistor={persistor}>
            {/* <GoogleAuthProvider> */}
              <App />
                {/* </GoogleAuthProvider> */}
              </PersistGate>
            </ThemeProvider>
          </Provider>
        </BrowserRouter>
      </HelmetProvider>
      );
